import HttpRequest from './HttpRequest'

class GroupProvider extends HttpRequest {
  findAll (page = 1, limit = 10, config) {
    return this.get(`/user-group?page=${page}&limit=${limit}`, undefined, config)
  }

  findAllGroupCode (config) {
    return this.get('/user-group/group-code/all', undefined, config)
  }

  createGroup (payload) {
    return this.post('/user-group', payload)
  }

  updateGroup (id, payload) {
    return this.patch(`/user-group/${id}`, payload)
  }

  deleteGroup (id) {
    return this.delete(`/user-group/${id}`)
  }

  paginate (page = 1, limit = 10, search, status) {
    return this.get(`/user-group?page=${page}&limit=${limit}&search=${search}&status=${status}`)
  }
}

export default GroupProvider
